<template>
  <footer class="relative">
    <div class="py-10">
      <div class="container py-8 max-w-[1200px] px-10 sm:mx-auto">
        <div class="flex flex-wrap sm:justify-between justify-center">
          <div class="w-full sm:w-4/12 px-4 sm:px-8">
            <div class="dark:text-white">
              <a
                target="_blank"
                :href="marketingBaseUrl"
                class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
              >
                <div class="flex mt-[18px] ml-[-40px]">
                  <img
                    src="/img/notedsource-logo.svg"
                    class="block dark:hidden w-[200px] h-[45px]"
                    alt="Companies use NotedSource to find industry experts from universities"
                  />
                  <img
                    src="/img/notedsource-white-logo.svg"
                    class="hidden dark:block w-[200px] h-[45px]"
                    alt="Companies use NotedSource to find industry experts from universities"
                  />
                </div>
              </a>
              <p class="text-sm ml-0">
                222 Broadway, 22nd Floor<br />
                New York, NY 10038<br />
                <a class="underline" href="tel:650.542.9670">650.542.9670</a>
              </p>
              <p class="text-sm mt-5">Copyright © {{ date }}</p>
              <p class="text-sm mt-5">
                <a href="https://app.notedsource.io/terms">Privacy Policy</a
                ><br />
                <a href="https://app.notedsource.io/privacy">Terms of Use</a>
              </p>
            </div>
          </div>
          <div
            class="w-full sm:w-8/12 pl-4 sm:pl-8 pt-10 sm-pt:0 dark:text-white"
          >
            <p class="text-sm my-3">
              Research Compass uses 220+ million academic publications to answer
              questions with Retrieval Augmented Generation (RAG), re-ranking,
              and a prompt designed to surface differences in the sources. Some
              of the publications are open access and some are limited to the
              abstract. Our data pipeline starts with
              <a
                class="underline"
                href="https://pubmed.ncbi.nlm.nih.gov/"
                target="_blank"
                >PubMed</a
              >,
              <a class="underline" href="https://www.semanticscholar.org/"
                >Semantic Scholar</a
              >, <a class="underline" href="https://core.ac.uk/">CORE</a>,
              <a
                class="underline"
                href="https://www.ncbi.nlm.nih.gov/pmc/"
                target="_blank"
                >PubMed Central</a
              >, and
              <a class="underline" href="https://www.arxiv.org/" target="_blank"
                >arXiv</a
              >.
            </p>
            <p class="text-sm my-3">
              We supplement this data with our own transformations and
              additions, including data from publishers, organizations like
              <a
                class="underline"
                target="_blank"
                href="https://www.crossref.org/"
                >Crossref</a
              >
              (and their
              <a
                class="underline"
                target="_blank"
                href="https://www.crossref.org/documentation/retrieve-metadata/retraction-watch/"
                >Retraction Watch</a
              >
              database), lists of predatory journals, and journal rankings. We
              use AI classification tools to annotate these abstracts with
              metadata about referenced studies, surveys, datasets, experiment
              design, and other ways to evaluate scientific methods.
            </p>
            <p class="text-sm my-3">
              We are not affiliated with any of these organizations.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      marketingBaseUrl: import.meta.env.VITE_MARKETING_BASE_URL,
    };
  },
  mounted() {
    if (import.meta.env.VITE_GOOGLE_ADS_ID && this.$hj) {
      const gclidPromise = new Promise((resolve) => {
        window.gtag(
          "get",
          import.meta.env.VITE_GOOGLE_ADS_ID,
          "gclid",
          resolve,
        );
      });
      gclidPromise.then((gclid) => {
        if (gclid) {
          this.$hj("event", "google_cpc");
        }
      });
    }
    if (this.$hj) {
      this.$hj("event", `session_referrer_${window.document.referrer}`);
    }
  },
};
</script>
